import { bsh_isAdminUserDetailsPresent } from 'helpers/sf_browser_storage_helper';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const usePlatformSettings = () => {
  // Add selector for platform_settings
  const {
    current_account,
    platform_settings
  } = useSelector(state => ({
    current_account: state.accounts.current_account,
    platform_settings: state.PlatformSettings.platform_settings
  }));

  const isClicksProductEnabled = useMemo(() => {
    //- Retail accounts will only have leads and calls (if they want clicks we will need to upgrade them to enterprise
    // - Remove creatives tab on sidebar
    // -Remove any mention of clicks. Dropdown select boxes, analytics page, etc.
    return current_account && (current_account?.enterprise || platform_settings?.retail_clicks_enabled)
  }, [current_account, platform_settings?.retail_clicks_enabled]);

  const isSourceSettingsEnabled = useMemo(() => {
    // Disable the source settings tab
    return current_account && (current_account?.enterprise || platform_settings?.retail_source_settings_enabled)
  }, [current_account, platform_settings?.retail_source_settings_enabled])

  // Remove pixel conversion settings
  const isPixelConversionSettingsEnabled = useMemo(() => {
    return current_account && (current_account?.enterprise || platform_settings?.retail_pixel_conversion_settings_enabled)
  }, [current_account, platform_settings?.retail_pixel_conversion_settings_enabled])

  // - Disable profiles tab. Instead, we will add a new section to the campaign settings to control territory. We can put it right under targeting like this https://app.screencast.com/3IMnvsTMZLJLI 
  // - No bid adjustments available at territory level
  const isProfilesEnabled = useMemo(() => {
    return current_account && (current_account?.enterprise ||  platform_settings?.retail_profiles_enabled)
  }, [current_account, platform_settings?.retail_profiles_enabled])

  // - Remove metrics and columns across the app that may cause confusion and customer service calls on client view. We want to make everything simpler for the retail client view. For admin view we can keep everything how it currently is.
  // Calls dashboard - remove opportunities and searches https://app.screencast.com/dKQsj0TpyV7ss
  // Leads dashboard - remove opportunities, searches, won https://app.screencast.com/BtsN720u6zrD0 
  // Campaigns page - Remove queries, searches, impressions, cm, and pixels https://app.screencast.com/spU7YpkPoQ4aO 
  // Analytics page - Remove source type

  const isMetricsEnabled = useMemo(() => {
    return current_account && (current_account?.enterprise || bsh_isAdminUserDetailsPresent() || platform_settings?.retail_metrics_enabled)
  }, [current_account, platform_settings?.retail_metrics_enabled])


  const isInternalMetricsEnabled = useMemo(() => {
    return current_account && (current_account?.enterprise && current_account?.internal && platform_settings?.retail_metrics_enabled || bsh_isAdminUserDetailsPresent())
  }, [current_account, platform_settings?.retail_metrics_enabled])

  const isTargetingPackagesEnabled = useMemo(() => {
    return current_account && (current_account?.enterprise ||  platform_settings?.retail_targeting_packages_enabled)
  }, [current_account, platform_settings?.retail_targeting_packages_enabled])

  return {
    isClicksProductEnabled,
    isSourceSettingsEnabled,
    isPixelConversionSettingsEnabled,
    isProfilesEnabled,
    isMetricsEnabled,
    isInternalMetricsEnabled,
    isTargetingPackagesEnabled
  }
}

export default usePlatformSettings;